import { render, staticRenderFns } from "./myInfomation.vue?vue&type=template&id=30220177&scoped=true&"
import script from "./myInfomation.vue?vue&type=script&lang=js&"
export * from "./myInfomation.vue?vue&type=script&lang=js&"
import style0 from "./myInfomation.vue?vue&type=style&index=0&id=30220177&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30220177",
  null
  
)

export default component.exports